/* eslint-disable camelcase */
import { singleControlledAction } from 'src/types';
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import localEntityListInMenuItem from 'src/utils/mainMenuOperations/localEntityListInMenuItem';
import { id, orgColumn, row_menu } from 'src/utils/entityOperations/columns/basicColumns';
import { editable } from 'src/types/columnFlags';
const controlledActions = singleControlledAction(878);
const columns = () => {
    return [
        row_menu({ menuItemShortcuts: ['del', 'copy'] }),
        id({ hideWhenDisplaying: true }),
        { name: 'user_id', hideWhenDisplaying: true },
        { name: 'user_name', hideWhenDisplaying: true },
        { name: 'role_id', editable, references: 'controlled_actions.roles' },
        orgColumn({ name: 'org_id', editable }),
        { name: 'app_id', editable, references: 'apps.apps' },
        { name: 'role_is_inherited', label: 'Role is inherited', isCheckbox: true, headerInfoTip: 'If this field is true, that means that the user has a role assigned at a higher level app/tenant combination than the one which you are currently logged in to. Such records cannot be altered from the current interface.' }
    ];
};
const remoteEntityName = 'controlled_actions.roles_orgs_apps_to_users';
const localEntityName = remoteEntityName;
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    entityLabel: 'Role Assignment',
    entityLabelPlural: 'Role Assignments',
    entityIcon: 'mdi-accounts-outline',
    remoteEntityName,
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Role Assignments',
});
export default localEntity;
export const RoleAssignments__menuItem = () => (Object.assign({ label: 'User Role Assignments', icon: { name: 'mdi-accounts-outline' }, prefetch: true }, localEntityListInMenuItem({
    localEntityNameProp: localEntityName,
    tableIdProp: localEntityName
})));
